import { TStats } from '@sifrovacihra/shared-ui';

export const stats2025Z = {
    "cyphers": [
        {
            "Id": 1,
            "code": null,
            "name": null,
            "type": "S",
            "message": null,
            "points": 0,
            "cathegory": null,
            "hasPdf": false,
            "solution": false,
            "solved": false,
            "helps": null,
            "stars": 0.0,
            "votes": 0,
            "teams": 0
        },
        {
            "Id": 2,
            "code": null,
            "name": null,
            "type": "C",
            "message": null,
            "points": 0,
            "cathegory": null,
            "hasPdf": false,
            "solution": false,
            "solved": false,
            "helps": null,
            "stars": 0.0,
            "votes": 0,
            "teams": 0
        },
        {
            "Id": 3,
            "code": null,
            "name": null,
            "type": "C",
            "message": null,
            "points": 0,
            "cathegory": null,
            "hasPdf": false,
            "solution": false,
            "solved": false,
            "helps": null,
            "stars": 0.0,
            "votes": 0,
            "teams": 0
        },
        {
            "Id": 4,
            "code": null,
            "name": null,
            "type": "C",
            "message": null,
            "points": 0,
            "cathegory": null,
            "hasPdf": false,
            "solution": false,
            "solved": false,
            "helps": null,
            "stars": 0.0,
            "votes": 0,
            "teams": 0
        },
        {
            "Id": 5,
            "code": null,
            "name": null,
            "type": "C",
            "message": null,
            "points": 0,
            "cathegory": null,
            "hasPdf": false,
            "solution": false,
            "solved": false,
            "helps": null,
            "stars": 0.0,
            "votes": 0,
            "teams": 0
        },
        {
            "Id": 6,
            "code": null,
            "name": null,
            "type": "C",
            "message": null,
            "points": 0,
            "cathegory": null,
            "hasPdf": false,
            "solution": false,
            "solved": false,
            "helps": null,
            "stars": 0.0,
            "votes": 0,
            "teams": 0
        },
        {
            "Id": 7,
            "code": null,
            "name": null,
            "type": "C",
            "message": null,
            "points": 0,
            "cathegory": null,
            "hasPdf": false,
            "solution": false,
            "solved": false,
            "helps": null,
            "stars": 0.0,
            "votes": 0,
            "teams": 0
        },
        {
            "Id": 8,
            "code": null,
            "name": null,
            "type": "F",
            "message": null,
            "points": 0,
            "cathegory": null,
            "hasPdf": false,
            "solution": false,
            "solved": false,
            "helps": null,
            "stars": 0.0,
            "votes": 0,
            "teams": 0
        }
    ],
    "teams": [
        {
            "Id": 54,
            "Name": "Nazgúlci",
            "Phone": null,
            "Password": null,
            "Type": 0,
            "GameInfo": {
                "cypher": 8,
                "message": null,
                "Status": 0,
                "totalTime": "01:55:16",
                "points": 0
            },
            "Players": null,
            "Cathegory": null,
            "Payed": false
        },
        {
            "Id": 31,
            "Name": "ó náš pán krákorá",
            "Phone": null,
            "Password": null,
            "Type": 0,
            "GameInfo": {
                "cypher": 8,
                "message": null,
                "Status": 0,
                "totalTime": "02:11:20",
                "points": 0
            },
            "Players": null,
            "Cathegory": null,
            "Payed": false
        },
        {
            "Id": 45,
            "Name": "Hafcusovi ",
            "Phone": null,
            "Password": null,
            "Type": 0,
            "GameInfo": {
                "cypher": 8,
                "message": null,
                "Status": 0,
                "totalTime": "02:33:47",
                "points": 0
            },
            "Players": null,
            "Cathegory": null,
            "Payed": false
        },
        {
            "Id": 53,
            "Name": "Marcipáni",
            "Phone": null,
            "Password": null,
            "Type": 0,
            "GameInfo": {
                "cypher": 8,
                "message": null,
                "Status": 0,
                "totalTime": "02:39:58",
                "points": 0
            },
            "Players": null,
            "Cathegory": null,
            "Payed": false
        },
        {
            "Id": 28,
            "Name": "AnnaBel",
            "Phone": null,
            "Password": null,
            "Type": 0,
            "GameInfo": {
                "cypher": 8,
                "message": null,
                "Status": 0,
                "totalTime": "02:42:06",
                "points": 0
            },
            "Players": null,
            "Cathegory": null,
            "Payed": false
        },
        {
            "Id": 43,
            "Name": "Bob a Bobek",
            "Phone": null,
            "Password": null,
            "Type": 0,
            "GameInfo": {
                "cypher": 8,
                "message": null,
                "Status": 0,
                "totalTime": "02:46:06",
                "points": 0
            },
            "Players": null,
            "Cathegory": null,
            "Payed": false
        },
        {
            "Id": 40,
            "Name": "JAMB",
            "Phone": null,
            "Password": null,
            "Type": 0,
            "GameInfo": {
                "cypher": 8,
                "message": null,
                "Status": 0,
                "totalTime": "03:03:20",
                "points": 0
            },
            "Players": null,
            "Cathegory": null,
            "Payed": false
        },
        {
            "Id": 32,
            "Name": "#DEKA",
            "Phone": null,
            "Password": null,
            "Type": 0,
            "GameInfo": {
                "cypher": 8,
                "message": null,
                "Status": 0,
                "totalTime": "03:07:24",
                "points": 0
            },
            "Players": null,
            "Cathegory": null,
            "Payed": false
        },
        {
            "Id": 16,
            "Name": "Dvě sestry",
            "Phone": null,
            "Password": null,
            "Type": 0,
            "GameInfo": {
                "cypher": 8,
                "message": null,
                "Status": 0,
                "totalTime": "03:09:56",
                "points": 0
            },
            "Players": null,
            "Cathegory": null,
            "Payed": false
        },
        {
            "Id": 49,
            "Name": "Kočičky",
            "Phone": null,
            "Password": null,
            "Type": 0,
            "GameInfo": {
                "cypher": 8,
                "message": null,
                "Status": 0,
                "totalTime": "03:16:10",
                "points": 0
            },
            "Players": null,
            "Cathegory": null,
            "Payed": false
        },
        {
            "Id": 27,
            "Name": "Zdravé jádro",
            "Phone": null,
            "Password": null,
            "Type": 0,
            "GameInfo": {
                "cypher": 8,
                "message": null,
                "Status": 0,
                "totalTime": "03:18:48",
                "points": 0
            },
            "Players": null,
            "Cathegory": null,
            "Payed": false
        },
        {
            "Id": 34,
            "Name": "Tak určitě...",
            "Phone": null,
            "Password": null,
            "Type": 0,
            "GameInfo": {
                "cypher": 8,
                "message": null,
                "Status": 0,
                "totalTime": "03:20:12",
                "points": 0
            },
            "Players": null,
            "Cathegory": null,
            "Payed": false
        },
        {
            "Id": 5,
            "Name": "Cesta je cíl",
            "Phone": null,
            "Password": null,
            "Type": 0,
            "GameInfo": {
                "cypher": 8,
                "message": null,
                "Status": 0,
                "totalTime": "03:21:25",
                "points": 0
            },
            "Players": null,
            "Cathegory": null,
            "Payed": false
        },
        {
            "Id": 23,
            "Name": "Duhoví bobci",
            "Phone": null,
            "Password": null,
            "Type": 0,
            "GameInfo": {
                "cypher": 8,
                "message": null,
                "Status": 0,
                "totalTime": "03:33:42",
                "points": 0
            },
            "Players": null,
            "Cathegory": null,
            "Payed": false
        },
        {
            "Id": 12,
            "Name": "Čendáno",
            "Phone": null,
            "Password": null,
            "Type": 0,
            "GameInfo": {
                "cypher": 8,
                "message": null,
                "Status": 0,
                "totalTime": "03:35:50",
                "points": 0
            },
            "Players": null,
            "Cathegory": null,
            "Payed": false
        },
        {
            "Id": 41,
            "Name": "Kdo neblokuje, nežije",
            "Phone": null,
            "Password": null,
            "Type": 0,
            "GameInfo": {
                "cypher": 8,
                "message": null,
                "Status": 0,
                "totalTime": "03:37:19",
                "points": 0
            },
            "Players": null,
            "Cathegory": null,
            "Payed": false
        },
        {
            "Id": 14,
            "Name": "Havran",
            "Phone": null,
            "Password": null,
            "Type": 0,
            "GameInfo": {
                "cypher": 8,
                "message": null,
                "Status": 0,
                "totalTime": "03:46:34",
                "points": 0
            },
            "Players": null,
            "Cathegory": null,
            "Payed": false
        },
        {
            "Id": 56,
            "Name": "Potkali se v Táboře",
            "Phone": null,
            "Password": null,
            "Type": 0,
            "GameInfo": {
                "cypher": 8,
                "message": null,
                "Status": 0,
                "totalTime": "03:48:22",
                "points": 0
            },
            "Players": null,
            "Cathegory": null,
            "Payed": false
        },
        {
            "Id": 29,
            "Name": "N22",
            "Phone": null,
            "Password": null,
            "Type": 0,
            "GameInfo": {
                "cypher": 8,
                "message": null,
                "Status": 0,
                "totalTime": "03:49:14",
                "points": 0
            },
            "Players": null,
            "Cathegory": null,
            "Payed": false
        },
        {
            "Id": 25,
            "Name": "Houbičky",
            "Phone": null,
            "Password": null,
            "Type": 0,
            "GameInfo": {
                "cypher": 8,
                "message": null,
                "Status": 0,
                "totalTime": "03:53:20",
                "points": 0
            },
            "Players": null,
            "Cathegory": null,
            "Payed": false
        },
        {
            "Id": 52,
            "Name": "Psi(chopati)",
            "Phone": null,
            "Password": null,
            "Type": 0,
            "GameInfo": {
                "cypher": 8,
                "message": null,
                "Status": 0,
                "totalTime": "03:59:44",
                "points": 0
            },
            "Players": null,
            "Cathegory": null,
            "Payed": false
        },
        {
            "Id": 46,
            "Name": "Diskvalifikace",
            "Phone": null,
            "Password": null,
            "Type": 0,
            "GameInfo": {
                "cypher": 8,
                "message": null,
                "Status": 0,
                "totalTime": "04:01:14",
                "points": 0
            },
            "Players": null,
            "Cathegory": null,
            "Payed": false
        },
        {
            "Id": 42,
            "Name": "Studny",
            "Phone": null,
            "Password": null,
            "Type": 0,
            "GameInfo": {
                "cypher": 8,
                "message": null,
                "Status": 0,
                "totalTime": "04:22:33",
                "points": 0
            },
            "Players": null,
            "Cathegory": null,
            "Payed": false
        },
        {
            "Id": 30,
            "Name": "Minidisco",
            "Phone": null,
            "Password": null,
            "Type": 0,
            "GameInfo": {
                "cypher": 8,
                "message": null,
                "Status": 0,
                "totalTime": "04:32:56",
                "points": 0
            },
            "Players": null,
            "Cathegory": null,
            "Payed": false
        },
        {
            "Id": 10,
            "Name": "Jezvinky",
            "Phone": null,
            "Password": null,
            "Type": 0,
            "GameInfo": {
                "cypher": 8,
                "message": null,
                "Status": 0,
                "totalTime": "04:55:33",
                "points": 0
            },
            "Players": null,
            "Cathegory": null,
            "Payed": false
        },
        {
            "Id": 26,
            "Name": "Tradiční Trio",
            "Phone": null,
            "Password": null,
            "Type": 0,
            "GameInfo": {
                "cypher": 8,
                "message": null,
                "Status": 0,
                "totalTime": "05:41:09",
                "points": 0
            },
            "Players": null,
            "Cathegory": null,
            "Payed": false
        },
        {
            "Id": 19,
            "Name": "Killer Queens",
            "Phone": null,
            "Password": null,
            "Type": 0,
            "GameInfo": {
                "cypher": 8,
                "message": null,
                "Status": 0,
                "totalTime": "06:13:23",
                "points": 0
            },
            "Players": null,
            "Cathegory": null,
            "Payed": false
        },
        {
            "Id": 17,
            "Name": "Jahodovej nanuk",
            "Phone": null,
            "Password": null,
            "Type": 0,
            "GameInfo": {
                "cypher": 8,
                "message": null,
                "Status": 0,
                "totalTime": "07:12:28",
                "points": 0
            },
            "Players": null,
            "Cathegory": null,
            "Payed": false
        }
    ],
    "teamCyphers": [
        {
            "id_team": 37,
            "id_cypher": 1,
            "time": "2025-05-24T09:00:08",
            "minusPoints": 0
        },
        {
            "id_team": 24,
            "id_cypher": 1,
            "time": "2025-05-24T09:00:46",
            "minusPoints": 0
        },
        {
            "id_team": 12,
            "id_cypher": 1,
            "time": "2025-05-24T09:02:22",
            "minusPoints": 0
        },
        {
            "id_team": 36,
            "id_cypher": 1,
            "time": "2025-05-24T09:03:13",
            "minusPoints": 0
        },
        {
            "id_team": 32,
            "id_cypher": 1,
            "time": "2025-05-24T09:03:14",
            "minusPoints": 0
        },
        {
            "id_team": 16,
            "id_cypher": 1,
            "time": "2025-05-24T09:03:17",
            "minusPoints": 0
        },
        {
            "id_team": 14,
            "id_cypher": 1,
            "time": "2025-05-24T09:03:19",
            "minusPoints": 0
        },
        {
            "id_team": 57,
            "id_cypher": 1,
            "time": "2025-05-24T09:03:21",
            "minusPoints": 0
        },
        {
            "id_team": 34,
            "id_cypher": 1,
            "time": "2025-05-24T09:03:28",
            "minusPoints": 0
        },
        {
            "id_team": 42,
            "id_cypher": 1,
            "time": "2025-05-24T09:03:29",
            "minusPoints": 0
        },
        {
            "id_team": 15,
            "id_cypher": 1,
            "time": "2025-05-24T09:03:32",
            "minusPoints": 0
        },
        {
            "id_team": 26,
            "id_cypher": 1,
            "time": "2025-05-24T09:03:41",
            "minusPoints": 0
        },
        {
            "id_team": 56,
            "id_cypher": 1,
            "time": "2025-05-24T09:03:41",
            "minusPoints": 0
        },
        {
            "id_team": 21,
            "id_cypher": 1,
            "time": "2025-05-24T09:03:48",
            "minusPoints": 0
        },
        {
            "id_team": 50,
            "id_cypher": 1,
            "time": "2025-05-24T09:03:52",
            "minusPoints": 0
        },
        {
            "id_team": 29,
            "id_cypher": 1,
            "time": "2025-05-24T09:03:53",
            "minusPoints": 0
        },
        {
            "id_team": 33,
            "id_cypher": 1,
            "time": "2025-05-24T09:03:54",
            "minusPoints": 0
        },
        {
            "id_team": 20,
            "id_cypher": 1,
            "time": "2025-05-24T09:03:55",
            "minusPoints": 0
        },
        {
            "id_team": 31,
            "id_cypher": 1,
            "time": "2025-05-24T09:03:59",
            "minusPoints": 0
        },
        {
            "id_team": 10,
            "id_cypher": 1,
            "time": "2025-05-24T09:04:08",
            "minusPoints": 0
        },
        {
            "id_team": 22,
            "id_cypher": 1,
            "time": "2025-05-24T09:04:11",
            "minusPoints": 0
        },
        {
            "id_team": 40,
            "id_cypher": 1,
            "time": "2025-05-24T09:04:17",
            "minusPoints": 0
        },
        {
            "id_team": 38,
            "id_cypher": 1,
            "time": "2025-05-24T09:04:36",
            "minusPoints": 0
        },
        {
            "id_team": 49,
            "id_cypher": 1,
            "time": "2025-05-24T09:04:42",
            "minusPoints": 0
        },
        {
            "id_team": 44,
            "id_cypher": 1,
            "time": "2025-05-24T09:23:45",
            "minusPoints": 0
        },
        {
            "id_team": 53,
            "id_cypher": 1,
            "time": "2025-05-24T09:23:51",
            "minusPoints": 0
        },
        {
            "id_team": 20,
            "id_cypher": 2,
            "time": "2025-05-24T09:27:24",
            "minusPoints": 0
        },
        {
            "id_team": 23,
            "id_cypher": 1,
            "time": "2025-05-24T09:29:30",
            "minusPoints": 0
        },
        {
            "id_team": 39,
            "id_cypher": 1,
            "time": "2025-05-24T09:30:45",
            "minusPoints": 0
        },
        {
            "id_team": 17,
            "id_cypher": 1,
            "time": "2025-05-24T09:30:48",
            "minusPoints": 0
        },
        {
            "id_team": 5,
            "id_cypher": 1,
            "time": "2025-05-24T09:31:16",
            "minusPoints": 0
        },
        {
            "id_team": 20,
            "id_cypher": 3,
            "time": "2025-05-24T09:35:29",
            "minusPoints": 0
        },
        {
            "id_team": 47,
            "id_cypher": 1,
            "time": "2025-05-24T09:35:43",
            "minusPoints": 0
        },
        {
            "id_team": 58,
            "id_cypher": 1,
            "time": "2025-05-24T09:37:19",
            "minusPoints": 0
        },
        {
            "id_team": 41,
            "id_cypher": 1,
            "time": "2025-05-24T09:37:46",
            "minusPoints": 0
        },
        {
            "id_team": 31,
            "id_cypher": 2,
            "time": "2025-05-24T09:39:20",
            "minusPoints": 0
        },
        {
            "id_team": 45,
            "id_cypher": 2,
            "time": "2025-05-24T09:40:15",
            "minusPoints": 0
        },
        {
            "id_team": 50,
            "id_cypher": 2,
            "time": "2025-05-24T09:46:02",
            "minusPoints": 0
        },
        {
            "id_team": 54,
            "id_cypher": 3,
            "time": "2025-05-24T09:49:54",
            "minusPoints": 0
        },
        {
            "id_team": 49,
            "id_cypher": 2,
            "time": "2025-05-24T09:54:54",
            "minusPoints": 0
        },
        {
            "id_team": 37,
            "id_cypher": 2,
            "time": "2025-05-24T09:54:57",
            "minusPoints": 0
        },
        {
            "id_team": 57,
            "id_cypher": 2,
            "time": "2025-05-24T10:15:50",
            "minusPoints": 0
        },
        {
            "id_team": 49,
            "id_cypher": 3,
            "time": "2025-05-24T10:20:19",
            "minusPoints": 0
        },
        {
            "id_team": 40,
            "id_cypher": 2,
            "time": "2025-05-24T10:24:06",
            "minusPoints": 0
        },
        {
            "id_team": 31,
            "id_cypher": 5,
            "time": "2025-05-24T10:26:26",
            "minusPoints": 0
        },
        {
            "id_team": 45,
            "id_cypher": 5,
            "time": "2025-05-24T10:27:00",
            "minusPoints": 0
        },
        {
            "id_team": 23,
            "id_cypher": 3,
            "time": "2025-05-24T10:29:04",
            "minusPoints": 0
        },
        {
            "id_team": 11,
            "id_cypher": 3,
            "time": "2025-05-24T10:29:15",
            "minusPoints": 0
        },
        {
            "id_team": 41,
            "id_cypher": 2,
            "time": "2025-05-24T10:32:08",
            "minusPoints": 0
        },
        {
            "id_team": 31,
            "id_cypher": 6,
            "time": "2025-05-24T10:36:11",
            "minusPoints": 0
        },
        {
            "id_team": 26,
            "id_cypher": 2,
            "time": "2025-05-24T10:36:15",
            "minusPoints": 0
        },
        {
            "id_team": 52,
            "id_cypher": 2,
            "time": "2025-05-24T10:36:32",
            "minusPoints": 0
        },
        {
            "id_team": 28,
            "id_cypher": 4,
            "time": "2025-05-24T10:37:04",
            "minusPoints": 0
        },
        {
            "id_team": 48,
            "id_cypher": 2,
            "time": "2025-05-24T10:40:50",
            "minusPoints": 0
        },
        {
            "id_team": 33,
            "id_cypher": 3,
            "time": "2025-05-24T10:43:54",
            "minusPoints": 0
        },
        {
            "id_team": 43,
            "id_cypher": 4,
            "time": "2025-05-24T10:45:12",
            "minusPoints": 0
        },
        {
            "id_team": 27,
            "id_cypher": 4,
            "time": "2025-05-24T10:51:58",
            "minusPoints": 0
        },
        {
            "id_team": 10,
            "id_cypher": 2,
            "time": "2025-05-24T10:52:37",
            "minusPoints": 0
        },
        {
            "id_team": 5,
            "id_cypher": 4,
            "time": "2025-05-24T10:52:41",
            "minusPoints": 0
        },
        {
            "id_team": 29,
            "id_cypher": 4,
            "time": "2025-05-24T10:55:14",
            "minusPoints": 0
        },
        {
            "id_team": 54,
            "id_cypher": 8,
            "time": "2025-05-24T10:55:16",
            "minusPoints": 0
        },
        {
            "id_team": 37,
            "id_cypher": 5,
            "time": "2025-05-24T10:55:18",
            "minusPoints": 0
        },
        {
            "id_team": 32,
            "id_cypher": 4,
            "time": "2025-05-24T10:57:55",
            "minusPoints": 0
        },
        {
            "id_team": 11,
            "id_cypher": 4,
            "time": "2025-05-24T10:58:25",
            "minusPoints": 0
        },
        {
            "id_team": 10,
            "id_cypher": 3,
            "time": "2025-05-24T10:59:52",
            "minusPoints": 0
        },
        {
            "id_team": 17,
            "id_cypher": 3,
            "time": "2025-05-24T10:59:57",
            "minusPoints": 0
        },
        {
            "id_team": 38,
            "id_cypher": 3,
            "time": "2025-05-24T11:00:15",
            "minusPoints": 0
        },
        {
            "id_team": 12,
            "id_cypher": 5,
            "time": "2025-05-24T11:00:55",
            "minusPoints": 0
        },
        {
            "id_team": 43,
            "id_cypher": 5,
            "time": "2025-05-24T11:01:13",
            "minusPoints": 0
        },
        {
            "id_team": 9,
            "id_cypher": 3,
            "time": "2025-05-24T11:01:20",
            "minusPoints": 0
        },
        {
            "id_team": 28,
            "id_cypher": 6,
            "time": "2025-05-24T11:01:25",
            "minusPoints": 0
        },
        {
            "id_team": 50,
            "id_cypher": 5,
            "time": "2025-05-24T11:01:35",
            "minusPoints": 0
        },
        {
            "id_team": 51,
            "id_cypher": 2,
            "time": "2025-05-24T11:02:20",
            "minusPoints": 0
        },
        {
            "id_team": 40,
            "id_cypher": 4,
            "time": "2025-05-24T11:03:24",
            "minusPoints": 0
        },
        {
            "id_team": 13,
            "id_cypher": 2,
            "time": "2025-05-24T11:05:51",
            "minusPoints": 0
        },
        {
            "id_team": 55,
            "id_cypher": 5,
            "time": "2025-05-24T11:08:39",
            "minusPoints": 0
        },
        {
            "id_team": 42,
            "id_cypher": 4,
            "time": "2025-05-24T11:08:57",
            "minusPoints": 0
        },
        {
            "id_team": 56,
            "id_cypher": 3,
            "time": "2025-05-24T11:09:50",
            "minusPoints": 0
        },
        {
            "id_team": 43,
            "id_cypher": 6,
            "time": "2025-05-24T11:10:42",
            "minusPoints": 0
        },
        {
            "id_team": 31,
            "id_cypher": 8,
            "time": "2025-05-24T11:11:20",
            "minusPoints": 0
        },
        {
            "id_team": 12,
            "id_cypher": 6,
            "time": "2025-05-24T11:13:49",
            "minusPoints": 0
        },
        {
            "id_team": 51,
            "id_cypher": 3,
            "time": "2025-05-24T11:15:54",
            "minusPoints": 0
        },
        {
            "id_team": 39,
            "id_cypher": 4,
            "time": "2025-05-24T11:16:24",
            "minusPoints": 0
        },
        {
            "id_team": 10,
            "id_cypher": 4,
            "time": "2025-05-24T11:17:15",
            "minusPoints": 0
        },
        {
            "id_team": 14,
            "id_cypher": 4,
            "time": "2025-05-24T11:18:49",
            "minusPoints": 0
        },
        {
            "id_team": 47,
            "id_cypher": 4,
            "time": "2025-05-24T11:19:04",
            "minusPoints": 0
        },
        {
            "id_team": 40,
            "id_cypher": 5,
            "time": "2025-05-24T11:19:35",
            "minusPoints": 0
        },
        {
            "id_team": 27,
            "id_cypher": 5,
            "time": "2025-05-24T11:20:29",
            "minusPoints": 0
        },
        {
            "id_team": 32,
            "id_cypher": 5,
            "time": "2025-05-24T11:20:32",
            "minusPoints": 0
        },
        {
            "id_team": 42,
            "id_cypher": 5,
            "time": "2025-05-24T11:24:42",
            "minusPoints": 0
        },
        {
            "id_team": 27,
            "id_cypher": 6,
            "time": "2025-05-24T11:26:17",
            "minusPoints": 0
        },
        {
            "id_team": 19,
            "id_cypher": 4,
            "time": "2025-05-24T11:28:55",
            "minusPoints": 0
        },
        {
            "id_team": 13,
            "id_cypher": 3,
            "time": "2025-05-24T11:29:45",
            "minusPoints": 0
        },
        {
            "id_team": 25,
            "id_cypher": 6,
            "time": "2025-05-24T11:31:26",
            "minusPoints": 0
        },
        {
            "id_team": 32,
            "id_cypher": 6,
            "time": "2025-05-24T11:32:58",
            "minusPoints": 0
        },
        {
            "id_team": 17,
            "id_cypher": 4,
            "time": "2025-05-24T11:33:44",
            "minusPoints": 0
        },
        {
            "id_team": 34,
            "id_cypher": 6,
            "time": "2025-05-24T11:33:47",
            "minusPoints": 0
        },
        {
            "id_team": 41,
            "id_cypher": 5,
            "time": "2025-05-24T11:34:08",
            "minusPoints": 0
        },
        {
            "id_team": 50,
            "id_cypher": 6,
            "time": "2025-05-24T11:34:10",
            "minusPoints": 0
        },
        {
            "id_team": 28,
            "id_cypher": 7,
            "time": "2025-05-24T11:34:33",
            "minusPoints": 0
        },
        {
            "id_team": 48,
            "id_cypher": 4,
            "time": "2025-05-24T11:36:07",
            "minusPoints": 0
        },
        {
            "id_team": 20,
            "id_cypher": 9,
            "time": "2025-05-24T11:37:16",
            "minusPoints": 0
        },
        {
            "id_team": 37,
            "id_cypher": 7,
            "time": "2025-05-24T11:37:37",
            "minusPoints": 0
        },
        {
            "id_team": 58,
            "id_cypher": 3,
            "time": "2025-05-24T11:39:14",
            "minusPoints": 0
        },
        {
            "id_team": 41,
            "id_cypher": 6,
            "time": "2025-05-24T11:40:34",
            "minusPoints": 0
        },
        {
            "id_team": 42,
            "id_cypher": 6,
            "time": "2025-05-24T11:41:07",
            "minusPoints": 0
        },
        {
            "id_team": 15,
            "id_cypher": 5,
            "time": "2025-05-24T11:42:31",
            "minusPoints": 0
        },
        {
            "id_team": 29,
            "id_cypher": 6,
            "time": "2025-05-24T11:45:07",
            "minusPoints": 0
        },
        {
            "id_team": 26,
            "id_cypher": 4,
            "time": "2025-05-24T11:45:38",
            "minusPoints": 0
        },
        {
            "id_team": 43,
            "id_cypher": 8,
            "time": "2025-05-24T11:46:06",
            "minusPoints": 0
        },
        {
            "id_team": 5,
            "id_cypher": 7,
            "time": "2025-05-24T11:48:01",
            "minusPoints": 0
        },
        {
            "id_team": 32,
            "id_cypher": 7,
            "time": "2025-05-24T11:48:30",
            "minusPoints": 0
        },
        {
            "id_team": 56,
            "id_cypher": 5,
            "time": "2025-05-24T11:49:18",
            "minusPoints": 0
        },
        {
            "id_team": 36,
            "id_cypher": 5,
            "time": "2025-05-24T11:49:39",
            "minusPoints": 0
        },
        {
            "id_team": 20,
            "id_cypher": 10,
            "time": "2025-05-24T11:49:47",
            "minusPoints": 0
        },
        {
            "id_team": 52,
            "id_cypher": 5,
            "time": "2025-05-24T11:50:20",
            "minusPoints": 0
        },
        {
            "id_team": 37,
            "id_cypher": 8,
            "time": "2025-05-24T11:50:21",
            "minusPoints": 0
        },
        {
            "id_team": 24,
            "id_cypher": 3,
            "time": "2025-05-24T11:51:25",
            "minusPoints": 0
        },
        {
            "id_team": 46,
            "id_cypher": 5,
            "time": "2025-05-24T11:58:43",
            "minusPoints": 0
        },
        {
            "id_team": 55,
            "id_cypher": 6,
            "time": "2025-05-24T12:01:03",
            "minusPoints": 0
        },
        {
            "id_team": 40,
            "id_cypher": 8,
            "time": "2025-05-24T12:03:20",
            "minusPoints": 0
        },
        {
            "id_team": 50,
            "id_cypher": 8,
            "time": "2025-05-24T12:03:37",
            "minusPoints": 0
        },
        {
            "id_team": 52,
            "id_cypher": 6,
            "time": "2025-05-24T12:07:12",
            "minusPoints": 0
        },
        {
            "id_team": 13,
            "id_cypher": 4,
            "time": "2025-05-24T12:07:15",
            "minusPoints": 0
        },
        {
            "id_team": 21,
            "id_cypher": 5,
            "time": "2025-05-24T12:12:11",
            "minusPoints": 0
        },
        {
            "id_team": 29,
            "id_cypher": 7,
            "time": "2025-05-24T12:13:06",
            "minusPoints": 0
        },
        {
            "id_team": 26,
            "id_cypher": 5,
            "time": "2025-05-24T12:14:21",
            "minusPoints": 0
        },
        {
            "id_team": 14,
            "id_cypher": 7,
            "time": "2025-05-24T12:14:31",
            "minusPoints": 0
        },
        {
            "id_team": 34,
            "id_cypher": 8,
            "time": "2025-05-24T12:20:12",
            "minusPoints": 0
        },
        {
            "id_team": 37,
            "id_cypher": 9,
            "time": "2025-05-24T12:21:09",
            "minusPoints": 0
        },
        {
            "id_team": 52,
            "id_cypher": 7,
            "time": "2025-05-24T12:22:41",
            "minusPoints": 0
        },
        {
            "id_team": 55,
            "id_cypher": 7,
            "time": "2025-05-24T12:22:58",
            "minusPoints": 0
        },
        {
            "id_team": 25,
            "id_cypher": 8,
            "time": "2025-05-24T12:23:20",
            "minusPoints": 0
        },
        {
            "id_team": 14,
            "id_cypher": 8,
            "time": "2025-05-24T12:31:34",
            "minusPoints": 0
        },
        {
            "id_team": 36,
            "id_cypher": 6,
            "time": "2025-05-24T12:31:53",
            "minusPoints": 0
        },
        {
            "id_team": 30,
            "id_cypher": 8,
            "time": "2025-05-24T12:32:56",
            "minusPoints": 0
        },
        {
            "id_team": 56,
            "id_cypher": 8,
            "time": "2025-05-24T12:33:22",
            "minusPoints": 0
        },
        {
            "id_team": 23,
            "id_cypher": 8,
            "time": "2025-05-24T12:33:42",
            "minusPoints": 0
        },
        {
            "id_team": 11,
            "id_cypher": 6,
            "time": "2025-05-24T12:33:50",
            "minusPoints": 0
        },
        {
            "id_team": 29,
            "id_cypher": 8,
            "time": "2025-05-24T12:34:14",
            "minusPoints": 0
        },
        {
            "id_team": 48,
            "id_cypher": 5,
            "time": "2025-05-24T12:34:23",
            "minusPoints": 0
        },
        {
            "id_team": 33,
            "id_cypher": 6,
            "time": "2025-05-24T12:38:09",
            "minusPoints": 0
        },
        {
            "id_team": 37,
            "id_cypher": 10,
            "time": "2025-05-24T12:38:45",
            "minusPoints": 0
        },
        {
            "id_team": 50,
            "id_cypher": 9,
            "time": "2025-05-24T12:39:01",
            "minusPoints": 0
        },
        {
            "id_team": 46,
            "id_cypher": 7,
            "time": "2025-05-24T12:39:36",
            "minusPoints": 0
        },
        {
            "id_team": 19,
            "id_cypher": 7,
            "time": "2025-05-24T12:41:02",
            "minusPoints": 0
        },
        {
            "id_team": 17,
            "id_cypher": 6,
            "time": "2025-05-24T12:44:27",
            "minusPoints": 0
        },
        {
            "id_team": 21,
            "id_cypher": 6,
            "time": "2025-05-24T12:49:28",
            "minusPoints": 0
        },
        {
            "id_team": 9,
            "id_cypher": 6,
            "time": "2025-05-24T12:52:25",
            "minusPoints": 0
        },
        {
            "id_team": 51,
            "id_cypher": 4,
            "time": "2025-05-24T12:55:18",
            "minusPoints": 0
        },
        {
            "id_team": 26,
            "id_cypher": 7,
            "time": "2025-05-24T13:00:16",
            "minusPoints": 0
        },
        {
            "id_team": 38,
            "id_cypher": 5,
            "time": "2025-05-24T13:04:28",
            "minusPoints": 0
        },
        {
            "id_team": 24,
            "id_cypher": 4,
            "time": "2025-05-24T13:06:45",
            "minusPoints": 0
        },
        {
            "id_team": 17,
            "id_cypher": 7,
            "time": "2025-05-24T13:11:34",
            "minusPoints": 0
        },
        {
            "id_team": 39,
            "id_cypher": 7,
            "time": "2025-05-24T13:14:05",
            "minusPoints": 0
        },
        {
            "id_team": 33,
            "id_cypher": 7,
            "time": "2025-05-24T13:15:41",
            "minusPoints": 0
        },
        {
            "id_team": 58,
            "id_cypher": 5,
            "time": "2025-05-24T13:16:21",
            "minusPoints": 0
        },
        {
            "id_team": 11,
            "id_cypher": 7,
            "time": "2025-05-24T13:16:50",
            "minusPoints": 0
        },
        {
            "id_team": 57,
            "id_cypher": 9,
            "time": "2025-05-24T13:20:41",
            "minusPoints": 0
        },
        {
            "id_team": 55,
            "id_cypher": 9,
            "time": "2025-05-24T13:23:07",
            "minusPoints": 0
        },
        {
            "id_team": 48,
            "id_cypher": 6,
            "time": "2025-05-24T13:24:13",
            "minusPoints": 0
        },
        {
            "id_team": 51,
            "id_cypher": 5,
            "time": "2025-05-24T13:30:50",
            "minusPoints": 0
        },
        {
            "id_team": 58,
            "id_cypher": 6,
            "time": "2025-05-24T13:33:16",
            "minusPoints": 0
        },
        {
            "id_team": 39,
            "id_cypher": 8,
            "time": "2025-05-24T13:37:06",
            "minusPoints": 0
        },
        {
            "id_team": 36,
            "id_cypher": 8,
            "time": "2025-05-24T13:38:58",
            "minusPoints": 0
        },
        {
            "id_team": 57,
            "id_cypher": 10,
            "time": "2025-05-24T13:42:39",
            "minusPoints": 0
        },
        {
            "id_team": 15,
            "id_cypher": 7,
            "time": "2025-05-24T13:44:02",
            "minusPoints": 0
        },
        {
            "id_team": 11,
            "id_cypher": 8,
            "time": "2025-05-24T13:44:14",
            "minusPoints": 0
        },
        {
            "id_team": 9,
            "id_cypher": 7,
            "time": "2025-05-24T13:46:30",
            "minusPoints": 0
        },
        {
            "id_team": 24,
            "id_cypher": 6,
            "time": "2025-05-24T13:55:11",
            "minusPoints": 0
        },
        {
            "id_team": 13,
            "id_cypher": 6,
            "time": "2025-05-24T13:56:52",
            "minusPoints": 0
        },
        {
            "id_team": 48,
            "id_cypher": 7,
            "time": "2025-05-24T13:59:34",
            "minusPoints": 0
        },
        {
            "id_team": 9,
            "id_cypher": 1,
            "time": "2025-05-24T09:03:24",
            "minusPoints": 0
        },
        {
            "id_team": 30,
            "id_cypher": 1,
            "time": "2025-05-24T09:03:37",
            "minusPoints": 0
        },
        {
            "id_team": 54,
            "id_cypher": 1,
            "time": "2025-05-24T09:03:41",
            "minusPoints": 0
        },
        {
            "id_team": 11,
            "id_cypher": 1,
            "time": "2025-05-24T09:03:51",
            "minusPoints": 0
        },
        {
            "id_team": 19,
            "id_cypher": 1,
            "time": "2025-05-24T09:03:58",
            "minusPoints": 0
        },
        {
            "id_team": 45,
            "id_cypher": 1,
            "time": "2025-05-24T09:04:23",
            "minusPoints": 0
        },
        {
            "id_team": 28,
            "id_cypher": 1,
            "time": "2025-05-24T09:04:37",
            "minusPoints": 0
        },
        {
            "id_team": 51,
            "id_cypher": 1,
            "time": "2025-05-24T09:06:00",
            "minusPoints": 0
        },
        {
            "id_team": 52,
            "id_cypher": 1,
            "time": "2025-05-24T09:12:58",
            "minusPoints": 0
        },
        {
            "id_team": 27,
            "id_cypher": 1,
            "time": "2025-05-24T09:14:51",
            "minusPoints": 0
        },
        {
            "id_team": 54,
            "id_cypher": 2,
            "time": "2025-05-24T09:37:01",
            "minusPoints": 0
        },
        {
            "id_team": 46,
            "id_cypher": 1,
            "time": "2025-05-24T09:43:33",
            "minusPoints": 0
        },
        {
            "id_team": 55,
            "id_cypher": 1,
            "time": "2025-05-24T09:43:36",
            "minusPoints": 0
        },
        {
            "id_team": 55,
            "id_cypher": 2,
            "time": "2025-05-24T09:43:45",
            "minusPoints": 0
        },
        {
            "id_team": 31,
            "id_cypher": 3,
            "time": "2025-05-24T09:51:39",
            "minusPoints": 0
        },
        {
            "id_team": 53,
            "id_cypher": 2,
            "time": "2025-05-24T09:52:07",
            "minusPoints": 0
        },
        {
            "id_team": 28,
            "id_cypher": 2,
            "time": "2025-05-24T09:52:36",
            "minusPoints": 0
        },
        {
            "id_team": 48,
            "id_cypher": 1,
            "time": "2025-05-24T10:02:22",
            "minusPoints": 0
        },
        {
            "id_team": 54,
            "id_cypher": 4,
            "time": "2025-05-24T10:02:42",
            "minusPoints": 0
        },
        {
            "id_team": 27,
            "id_cypher": 2,
            "time": "2025-05-24T10:03:11",
            "minusPoints": 0
        },
        {
            "id_team": 16,
            "id_cypher": 2,
            "time": "2025-05-24T10:03:19",
            "minusPoints": 0
        },
        {
            "id_team": 22,
            "id_cypher": 2,
            "time": "2025-05-24T10:03:23",
            "minusPoints": 0
        },
        {
            "id_team": 25,
            "id_cypher": 1,
            "time": "2025-05-24T10:07:33",
            "minusPoints": 0
        },
        {
            "id_team": 37,
            "id_cypher": 3,
            "time": "2025-05-24T10:07:40",
            "minusPoints": 0
        },
        {
            "id_team": 43,
            "id_cypher": 1,
            "time": "2025-05-24T10:07:56",
            "minusPoints": 0
        },
        {
            "id_team": 43,
            "id_cypher": 2,
            "time": "2025-05-24T10:08:42",
            "minusPoints": 0
        },
        {
            "id_team": 45,
            "id_cypher": 4,
            "time": "2025-05-24T10:10:02",
            "minusPoints": 0
        },
        {
            "id_team": 31,
            "id_cypher": 4,
            "time": "2025-05-24T10:11:01",
            "minusPoints": 0
        },
        {
            "id_team": 53,
            "id_cypher": 3,
            "time": "2025-05-24T10:11:18",
            "minusPoints": 0
        },
        {
            "id_team": 36,
            "id_cypher": 2,
            "time": "2025-05-24T10:11:27",
            "minusPoints": 0
        },
        {
            "id_team": 20,
            "id_cypher": 5,
            "time": "2025-05-24T10:12:46",
            "minusPoints": 0
        },
        {
            "id_team": 29,
            "id_cypher": 2,
            "time": "2025-05-24T10:13:11",
            "minusPoints": 0
        },
        {
            "id_team": 22,
            "id_cypher": 3,
            "time": "2025-05-24T10:13:43",
            "minusPoints": 0
        },
        {
            "id_team": 38,
            "id_cypher": 2,
            "time": "2025-05-24T10:14:46",
            "minusPoints": 0
        },
        {
            "id_team": 32,
            "id_cypher": 2,
            "time": "2025-05-24T10:14:55",
            "minusPoints": 0
        },
        {
            "id_team": 5,
            "id_cypher": 2,
            "time": "2025-05-24T10:15:54",
            "minusPoints": 0
        },
        {
            "id_team": 30,
            "id_cypher": 2,
            "time": "2025-05-24T10:16:06",
            "minusPoints": 0
        },
        {
            "id_team": 54,
            "id_cypher": 5,
            "time": "2025-05-24T10:19:06",
            "minusPoints": 0
        },
        {
            "id_team": 11,
            "id_cypher": 2,
            "time": "2025-05-24T10:19:16",
            "minusPoints": 0
        },
        {
            "id_team": 12,
            "id_cypher": 3,
            "time": "2025-05-24T10:19:23",
            "minusPoints": 0
        },
        {
            "id_team": 25,
            "id_cypher": 2,
            "time": "2025-05-24T10:21:36",
            "minusPoints": 0
        },
        {
            "id_team": 43,
            "id_cypher": 3,
            "time": "2025-05-24T10:23:24",
            "minusPoints": 0
        },
        {
            "id_team": 50,
            "id_cypher": 4,
            "time": "2025-05-24T10:23:55",
            "minusPoints": 0
        },
        {
            "id_team": 57,
            "id_cypher": 3,
            "time": "2025-05-24T10:25:26",
            "minusPoints": 0
        },
        {
            "id_team": 33,
            "id_cypher": 2,
            "time": "2025-05-24T10:27:04",
            "minusPoints": 0
        },
        {
            "id_team": 55,
            "id_cypher": 4,
            "time": "2025-05-24T10:27:29",
            "minusPoints": 0
        },
        {
            "id_team": 47,
            "id_cypher": 2,
            "time": "2025-05-24T10:27:50",
            "minusPoints": 0
        },
        {
            "id_team": 15,
            "id_cypher": 2,
            "time": "2025-05-24T10:27:58",
            "minusPoints": 0
        },
        {
            "id_team": 54,
            "id_cypher": 6,
            "time": "2025-05-24T10:28:50",
            "minusPoints": 0
        },
        {
            "id_team": 53,
            "id_cypher": 4,
            "time": "2025-05-24T10:29:16",
            "minusPoints": 0
        },
        {
            "id_team": 13,
            "id_cypher": 1,
            "time": "2025-05-24T10:29:41",
            "minusPoints": 0
        },
        {
            "id_team": 5,
            "id_cypher": 3,
            "time": "2025-05-24T10:33:14",
            "minusPoints": 0
        },
        {
            "id_team": 29,
            "id_cypher": 3,
            "time": "2025-05-24T10:33:29",
            "minusPoints": 0
        },
        {
            "id_team": 42,
            "id_cypher": 2,
            "time": "2025-05-24T10:33:36",
            "minusPoints": 0
        },
        {
            "id_team": 27,
            "id_cypher": 3,
            "time": "2025-05-24T10:33:41",
            "minusPoints": 0
        },
        {
            "id_team": 49,
            "id_cypher": 4,
            "time": "2025-05-24T10:34:16",
            "minusPoints": 0
        },
        {
            "id_team": 34,
            "id_cypher": 2,
            "time": "2025-05-24T10:35:14",
            "minusPoints": 0
        },
        {
            "id_team": 21,
            "id_cypher": 2,
            "time": "2025-05-24T10:35:42",
            "minusPoints": 0
        },
        {
            "id_team": 16,
            "id_cypher": 4,
            "time": "2025-05-24T10:35:53",
            "minusPoints": 0
        },
        {
            "id_team": 47,
            "id_cypher": 3,
            "time": "2025-05-24T10:37:00",
            "minusPoints": 0
        },
        {
            "id_team": 30,
            "id_cypher": 3,
            "time": "2025-05-24T10:38:27",
            "minusPoints": 0
        },
        {
            "id_team": 25,
            "id_cypher": 3,
            "time": "2025-05-24T10:38:38",
            "minusPoints": 0
        },
        {
            "id_team": 48,
            "id_cypher": 3,
            "time": "2025-05-24T10:40:59",
            "minusPoints": 0
        },
        {
            "id_team": 32,
            "id_cypher": 3,
            "time": "2025-05-24T10:41:09",
            "minusPoints": 0
        },
        {
            "id_team": 17,
            "id_cypher": 2,
            "time": "2025-05-24T10:41:16",
            "minusPoints": 0
        },
        {
            "id_team": 54,
            "id_cypher": 7,
            "time": "2025-05-24T10:41:31",
            "minusPoints": 0
        },
        {
            "id_team": 15,
            "id_cypher": 3,
            "time": "2025-05-24T10:43:04",
            "minusPoints": 0
        },
        {
            "id_team": 40,
            "id_cypher": 3,
            "time": "2025-05-24T10:43:05",
            "minusPoints": 0
        },
        {
            "id_team": 24,
            "id_cypher": 2,
            "time": "2025-05-24T10:43:53",
            "minusPoints": 0
        },
        {
            "id_team": 58,
            "id_cypher": 2,
            "time": "2025-05-24T10:43:55",
            "minusPoints": 0
        },
        {
            "id_team": 19,
            "id_cypher": 2,
            "time": "2025-05-24T10:45:34",
            "minusPoints": 0
        },
        {
            "id_team": 45,
            "id_cypher": 6,
            "time": "2025-05-24T10:47:23",
            "minusPoints": 0
        },
        {
            "id_team": 19,
            "id_cypher": 3,
            "time": "2025-05-24T10:47:25",
            "minusPoints": 0
        },
        {
            "id_team": 53,
            "id_cypher": 5,
            "time": "2025-05-24T10:47:33",
            "minusPoints": 0
        },
        {
            "id_team": 9,
            "id_cypher": 2,
            "time": "2025-05-24T10:48:57",
            "minusPoints": 0
        },
        {
            "id_team": 31,
            "id_cypher": 7,
            "time": "2025-05-24T10:49:46",
            "minusPoints": 0
        },
        {
            "id_team": 57,
            "id_cypher": 4,
            "time": "2025-05-24T10:55:03",
            "minusPoints": 0
        },
        {
            "id_team": 41,
            "id_cypher": 3,
            "time": "2025-05-24T10:56:04",
            "minusPoints": 0
        },
        {
            "id_team": 30,
            "id_cypher": 4,
            "time": "2025-05-24T10:58:32",
            "minusPoints": 0
        },
        {
            "id_team": 20,
            "id_cypher": 7,
            "time": "2025-05-24T11:03:38",
            "minusPoints": 0
        },
        {
            "id_team": 53,
            "id_cypher": 6,
            "time": "2025-05-24T11:04:06",
            "minusPoints": 0
        },
        {
            "id_team": 26,
            "id_cypher": 3,
            "time": "2025-05-24T11:07:10",
            "minusPoints": 0
        },
        {
            "id_team": 46,
            "id_cypher": 3,
            "time": "2025-05-24T11:07:23",
            "minusPoints": 0
        },
        {
            "id_team": 34,
            "id_cypher": 4,
            "time": "2025-05-24T11:07:45",
            "minusPoints": 0
        },
        {
            "id_team": 21,
            "id_cypher": 4,
            "time": "2025-05-24T11:17:53",
            "minusPoints": 0
        },
        {
            "id_team": 34,
            "id_cypher": 5,
            "time": "2025-05-24T11:21:33",
            "minusPoints": 0
        },
        {
            "id_team": 37,
            "id_cypher": 6,
            "time": "2025-05-24T11:21:46",
            "minusPoints": 0
        },
        {
            "id_team": 5,
            "id_cypher": 6,
            "time": "2025-05-24T11:23:03",
            "minusPoints": 0
        },
        {
            "id_team": 16,
            "id_cypher": 6,
            "time": "2025-05-24T11:26:33",
            "minusPoints": 0
        },
        {
            "id_team": 9,
            "id_cypher": 4,
            "time": "2025-05-24T11:29:01",
            "minusPoints": 0
        },
        {
            "id_team": 22,
            "id_cypher": 4,
            "time": "2025-05-24T11:35:21",
            "minusPoints": 0
        },
        {
            "id_team": 52,
            "id_cypher": 4,
            "time": "2025-05-24T11:36:13",
            "minusPoints": 0
        },
        {
            "id_team": 53,
            "id_cypher": 8,
            "time": "2025-05-24T11:39:58",
            "minusPoints": 0
        },
        {
            "id_team": 14,
            "id_cypher": 5,
            "time": "2025-05-24T11:40:40",
            "minusPoints": 0
        },
        {
            "id_team": 23,
            "id_cypher": 6,
            "time": "2025-05-24T11:42:49",
            "minusPoints": 0
        },
        {
            "id_team": 30,
            "id_cypher": 6,
            "time": "2025-05-24T11:44:14",
            "minusPoints": 0
        },
        {
            "id_team": 10,
            "id_cypher": 5,
            "time": "2025-05-24T11:50:47",
            "minusPoints": 0
        },
        {
            "id_team": 19,
            "id_cypher": 5,
            "time": "2025-05-24T11:52:50",
            "minusPoints": 0
        },
        {
            "id_team": 39,
            "id_cypher": 5,
            "time": "2025-05-24T11:54:13",
            "minusPoints": 0
        },
        {
            "id_team": 42,
            "id_cypher": 7,
            "time": "2025-05-24T11:56:43",
            "minusPoints": 0
        },
        {
            "id_team": 41,
            "id_cypher": 7,
            "time": "2025-05-24T11:58:53",
            "minusPoints": 0
        },
        {
            "id_team": 25,
            "id_cypher": 7,
            "time": "2025-05-24T11:59:23",
            "minusPoints": 0
        },
        {
            "id_team": 49,
            "id_cypher": 8,
            "time": "2025-05-24T12:01:10",
            "minusPoints": 0
        },
        {
            "id_team": 10,
            "id_cypher": 6,
            "time": "2025-05-24T12:03:24",
            "minusPoints": 0
        },
        {
            "id_team": 19,
            "id_cypher": 6,
            "time": "2025-05-24T12:03:29",
            "minusPoints": 0
        },
        {
            "id_team": 30,
            "id_cypher": 7,
            "time": "2025-05-24T12:05:01",
            "minusPoints": 0
        },
        {
            "id_team": 12,
            "id_cypher": 8,
            "time": "2025-05-24T12:05:50",
            "minusPoints": 0
        },
        {
            "id_team": 57,
            "id_cypher": 6,
            "time": "2025-05-24T12:05:58",
            "minusPoints": 0
        },
        {
            "id_team": 16,
            "id_cypher": 8,
            "time": "2025-05-24T12:09:56",
            "minusPoints": 0
        },
        {
            "id_team": 56,
            "id_cypher": 7,
            "time": "2025-05-24T12:13:55",
            "minusPoints": 0
        },
        {
            "id_team": 9,
            "id_cypher": 5,
            "time": "2025-05-24T12:16:23",
            "minusPoints": 0
        },
        {
            "id_team": 23,
            "id_cypher": 7,
            "time": "2025-05-24T12:16:30",
            "minusPoints": 0
        },
        {
            "id_team": 46,
            "id_cypher": 6,
            "time": "2025-05-24T12:19:01",
            "minusPoints": 0
        },
        {
            "id_team": 41,
            "id_cypher": 8,
            "time": "2025-05-24T12:22:19",
            "minusPoints": 0
        },
        {
            "id_team": 42,
            "id_cypher": 8,
            "time": "2025-05-24T12:22:33",
            "minusPoints": 0
        },
        {
            "id_team": 10,
            "id_cypher": 7,
            "time": "2025-05-24T12:27:53",
            "minusPoints": 0
        },
        {
            "id_team": 33,
            "id_cypher": 5,
            "time": "2025-05-24T12:29:01",
            "minusPoints": 0
        },
        {
            "id_team": 17,
            "id_cypher": 5,
            "time": "2025-05-24T12:31:34",
            "minusPoints": 0
        },
        {
            "id_team": 57,
            "id_cypher": 7,
            "time": "2025-05-24T12:36:05",
            "minusPoints": 0
        },
        {
            "id_team": 15,
            "id_cypher": 6,
            "time": "2025-05-24T12:36:13",
            "minusPoints": 0
        },
        {
            "id_team": 38,
            "id_cypher": 4,
            "time": "2025-05-24T12:38:48",
            "minusPoints": 0
        },
        {
            "id_team": 39,
            "id_cypher": 6,
            "time": "2025-05-24T12:42:10",
            "minusPoints": 0
        },
        {
            "id_team": 26,
            "id_cypher": 6,
            "time": "2025-05-24T12:43:37",
            "minusPoints": 0
        },
        {
            "id_team": 52,
            "id_cypher": 8,
            "time": "2025-05-24T12:44:44",
            "minusPoints": 0
        },
        {
            "id_team": 55,
            "id_cypher": 8,
            "time": "2025-05-24T12:46:05",
            "minusPoints": 0
        },
        {
            "id_team": 57,
            "id_cypher": 8,
            "time": "2025-05-24T12:47:00",
            "minusPoints": 0
        },
        {
            "id_team": 10,
            "id_cypher": 8,
            "time": "2025-05-24T12:55:33",
            "minusPoints": 0
        },
        {
            "id_team": 50,
            "id_cypher": 10,
            "time": "2025-05-24T12:55:39",
            "minusPoints": 0
        },
        {
            "id_team": 46,
            "id_cypher": 8,
            "time": "2025-05-24T13:01:14",
            "minusPoints": 0
        },
        {
            "id_team": 13,
            "id_cypher": 5,
            "time": "2025-05-24T13:12:55",
            "minusPoints": 0
        },
        {
            "id_team": 19,
            "id_cypher": 8,
            "time": "2025-05-24T13:13:23",
            "minusPoints": 0
        },
        {
            "id_team": 36,
            "id_cypher": 7,
            "time": "2025-05-24T13:22:35",
            "minusPoints": 0
        },
        {
            "id_team": 26,
            "id_cypher": 8,
            "time": "2025-05-24T13:26:09",
            "minusPoints": 0
        },
        {
            "id_team": 21,
            "id_cypher": 7,
            "time": "2025-05-24T13:30:30",
            "minusPoints": 0
        },
        {
            "id_team": 55,
            "id_cypher": 10,
            "time": "2025-05-24T13:41:32",
            "minusPoints": 0
        },
        {
            "id_team": 24,
            "id_cypher": 5,
            "time": "2025-05-24T13:42:13",
            "minusPoints": 0
        },
        {
            "id_team": 17,
            "id_cypher": 8,
            "time": "2025-05-24T13:42:28",
            "minusPoints": 0
        },
        {
            "id_team": 33,
            "id_cypher": 8,
            "time": "2025-05-24T13:44:19",
            "minusPoints": 0
        },
        {
            "id_team": 45,
            "id_cypher": 3,
            "time": "2025-05-24T09:52:26",
            "minusPoints": 0
        },
        {
            "id_team": 55,
            "id_cypher": 3,
            "time": "2025-05-24T09:56:57",
            "minusPoints": 0
        },
        {
            "id_team": 20,
            "id_cypher": 4,
            "time": "2025-05-24T09:57:14",
            "minusPoints": 0
        },
        {
            "id_team": 50,
            "id_cypher": 3,
            "time": "2025-05-24T09:59:44",
            "minusPoints": 0
        },
        {
            "id_team": 23,
            "id_cypher": 2,
            "time": "2025-05-24T10:02:25",
            "minusPoints": 0
        },
        {
            "id_team": 44,
            "id_cypher": 2,
            "time": "2025-05-24T10:08:09",
            "minusPoints": 0
        },
        {
            "id_team": 16,
            "id_cypher": 3,
            "time": "2025-05-24T10:13:15",
            "minusPoints": 0
        },
        {
            "id_team": 12,
            "id_cypher": 2,
            "time": "2025-05-24T10:13:19",
            "minusPoints": 0
        },
        {
            "id_team": 39,
            "id_cypher": 2,
            "time": "2025-05-24T10:15:13",
            "minusPoints": 0
        },
        {
            "id_team": 28,
            "id_cypher": 3,
            "time": "2025-05-24T10:23:18",
            "minusPoints": 0
        },
        {
            "id_team": 36,
            "id_cypher": 3,
            "time": "2025-05-24T10:26:12",
            "minusPoints": 0
        },
        {
            "id_team": 46,
            "id_cypher": 2,
            "time": "2025-05-24T10:29:56",
            "minusPoints": 0
        },
        {
            "id_team": 44,
            "id_cypher": 3,
            "time": "2025-05-24T10:33:09",
            "minusPoints": 0
        },
        {
            "id_team": 20,
            "id_cypher": 6,
            "time": "2025-05-24T10:35:46",
            "minusPoints": 0
        },
        {
            "id_team": 37,
            "id_cypher": 4,
            "time": "2025-05-24T10:35:49",
            "minusPoints": 0
        },
        {
            "id_team": 12,
            "id_cypher": 4,
            "time": "2025-05-24T10:38:08",
            "minusPoints": 0
        },
        {
            "id_team": 14,
            "id_cypher": 2,
            "time": "2025-05-24T10:39:07",
            "minusPoints": 0
        },
        {
            "id_team": 39,
            "id_cypher": 3,
            "time": "2025-05-24T10:47:03",
            "minusPoints": 0
        },
        {
            "id_team": 56,
            "id_cypher": 2,
            "time": "2025-05-24T10:48:45",
            "minusPoints": 0
        },
        {
            "id_team": 49,
            "id_cypher": 5,
            "time": "2025-05-24T10:49:21",
            "minusPoints": 0
        },
        {
            "id_team": 42,
            "id_cypher": 3,
            "time": "2025-05-24T10:49:53",
            "minusPoints": 0
        },
        {
            "id_team": 28,
            "id_cypher": 5,
            "time": "2025-05-24T10:50:15",
            "minusPoints": 0
        },
        {
            "id_team": 34,
            "id_cypher": 3,
            "time": "2025-05-24T10:51:45",
            "minusPoints": 0
        },
        {
            "id_team": 21,
            "id_cypher": 3,
            "time": "2025-05-24T10:52:21",
            "minusPoints": 0
        },
        {
            "id_team": 23,
            "id_cypher": 4,
            "time": "2025-05-24T10:54:48",
            "minusPoints": 0
        },
        {
            "id_team": 14,
            "id_cypher": 3,
            "time": "2025-05-24T10:58:05",
            "minusPoints": 0
        },
        {
            "id_team": 25,
            "id_cypher": 4,
            "time": "2025-05-24T10:58:32",
            "minusPoints": 0
        },
        {
            "id_team": 52,
            "id_cypher": 3,
            "time": "2025-05-24T11:00:43",
            "minusPoints": 0
        },
        {
            "id_team": 16,
            "id_cypher": 5,
            "time": "2025-05-24T11:00:48",
            "minusPoints": 0
        },
        {
            "id_team": 45,
            "id_cypher": 7,
            "time": "2025-05-24T11:07:41",
            "minusPoints": 0
        },
        {
            "id_team": 5,
            "id_cypher": 5,
            "time": "2025-05-24T11:09:54",
            "minusPoints": 0
        },
        {
            "id_team": 15,
            "id_cypher": 4,
            "time": "2025-05-24T11:12:18",
            "minusPoints": 0
        },
        {
            "id_team": 20,
            "id_cypher": 8,
            "time": "2025-05-24T11:15:13",
            "minusPoints": 0
        },
        {
            "id_team": 25,
            "id_cypher": 5,
            "time": "2025-05-24T11:17:28",
            "minusPoints": 0
        },
        {
            "id_team": 30,
            "id_cypher": 5,
            "time": "2025-05-24T11:18:39",
            "minusPoints": 0
        },
        {
            "id_team": 36,
            "id_cypher": 4,
            "time": "2025-05-24T11:19:33",
            "minusPoints": 0
        },
        {
            "id_team": 33,
            "id_cypher": 4,
            "time": "2025-05-24T11:19:47",
            "minusPoints": 0
        },
        {
            "id_team": 53,
            "id_cypher": 7,
            "time": "2025-05-24T11:19:57",
            "minusPoints": 0
        },
        {
            "id_team": 29,
            "id_cypher": 5,
            "time": "2025-05-24T11:20:22",
            "minusPoints": 0
        },
        {
            "id_team": 43,
            "id_cypher": 7,
            "time": "2025-05-24T11:24:38",
            "minusPoints": 0
        },
        {
            "id_team": 57,
            "id_cypher": 5,
            "time": "2025-05-24T11:24:49",
            "minusPoints": 0
        },
        {
            "id_team": 49,
            "id_cypher": 6,
            "time": "2025-05-24T11:25:03",
            "minusPoints": 0
        },
        {
            "id_team": 23,
            "id_cypher": 5,
            "time": "2025-05-24T11:27:21",
            "minusPoints": 0
        },
        {
            "id_team": 56,
            "id_cypher": 4,
            "time": "2025-05-24T11:28:19",
            "minusPoints": 0
        },
        {
            "id_team": 41,
            "id_cypher": 4,
            "time": "2025-05-24T11:28:38",
            "minusPoints": 0
        },
        {
            "id_team": 40,
            "id_cypher": 6,
            "time": "2025-05-24T11:31:15",
            "minusPoints": 0
        },
        {
            "id_team": 46,
            "id_cypher": 4,
            "time": "2025-05-24T11:32:42",
            "minusPoints": 0
        },
        {
            "id_team": 45,
            "id_cypher": 8,
            "time": "2025-05-24T11:33:47",
            "minusPoints": 0
        },
        {
            "id_team": 49,
            "id_cypher": 7,
            "time": "2025-05-24T11:36:50",
            "minusPoints": 0
        },
        {
            "id_team": 16,
            "id_cypher": 7,
            "time": "2025-05-24T11:37:23",
            "minusPoints": 0
        },
        {
            "id_team": 44,
            "id_cypher": 4,
            "time": "2025-05-24T11:39:40",
            "minusPoints": 0
        },
        {
            "id_team": 12,
            "id_cypher": 7,
            "time": "2025-05-24T11:40:40",
            "minusPoints": 0
        },
        {
            "id_team": 27,
            "id_cypher": 7,
            "time": "2025-05-24T11:41:18",
            "minusPoints": 0
        },
        {
            "id_team": 28,
            "id_cypher": 8,
            "time": "2025-05-24T11:42:06",
            "minusPoints": 0
        },
        {
            "id_team": 40,
            "id_cypher": 7,
            "time": "2025-05-24T11:45:25",
            "minusPoints": 0
        },
        {
            "id_team": 50,
            "id_cypher": 7,
            "time": "2025-05-24T11:46:53",
            "minusPoints": 0
        },
        {
            "id_team": 58,
            "id_cypher": 4,
            "time": "2025-05-24T11:52:07",
            "minusPoints": 0
        },
        {
            "id_team": 14,
            "id_cypher": 6,
            "time": "2025-05-24T11:53:26",
            "minusPoints": 0
        },
        {
            "id_team": 11,
            "id_cypher": 5,
            "time": "2025-05-24T11:55:20",
            "minusPoints": 0
        },
        {
            "id_team": 56,
            "id_cypher": 6,
            "time": "2025-05-24T12:02:46",
            "minusPoints": 0
        },
        {
            "id_team": 34,
            "id_cypher": 7,
            "time": "2025-05-24T12:03:13",
            "minusPoints": 0
        },
        {
            "id_team": 27,
            "id_cypher": 8,
            "time": "2025-05-24T12:03:48",
            "minusPoints": 0
        },
        {
            "id_team": 5,
            "id_cypher": 8,
            "time": "2025-05-24T12:06:25",
            "minusPoints": 0
        },
        {
            "id_team": 32,
            "id_cypher": 8,
            "time": "2025-05-24T12:07:24",
            "minusPoints": 0
        }
    ],
    "teamHelps": [
        {
            "id_team": 27,
            "help": {
                "Id": 1,
                "cypher": 1,
                "cathegory": null,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2025-05-24T09:30:42"
            }
        },
        {
            "id_team": 22,
            "help": {
                "Id": 22,
                "cypher": 1,
                "cathegory": null,
                "order": 1,
                "points": 30,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2025-05-24T09:36:23"
            }
        },
        {
            "id_team": 22,
            "help": {
                "Id": 23,
                "cypher": 1,
                "cathegory": null,
                "order": 2,
                "points": 30,
                "type": "I",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2025-05-24T09:41:21"
            }
        },
        {
            "id_team": 33,
            "help": {
                "Id": 22,
                "cypher": 1,
                "cathegory": null,
                "order": 1,
                "points": 30,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2025-05-24T09:44:19"
            }
        },
        {
            "id_team": 44,
            "help": {
                "Id": 22,
                "cypher": 1,
                "cathegory": null,
                "order": 1,
                "points": 30,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2025-05-24T09:45:05"
            }
        },
        {
            "id_team": 9,
            "help": {
                "Id": 22,
                "cypher": 1,
                "cathegory": null,
                "order": 1,
                "points": 30,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2025-05-24T09:57:04"
            }
        },
        {
            "id_team": 33,
            "help": {
                "Id": 24,
                "cypher": 1,
                "cathegory": null,
                "order": 3,
                "points": -60,
                "type": "A",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2025-05-24T10:16:51"
            }
        },
        {
            "id_team": 51,
            "help": {
                "Id": 23,
                "cypher": 1,
                "cathegory": null,
                "order": 2,
                "points": 30,
                "type": "I",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2025-05-24T10:24:39"
            }
        },
        {
            "id_team": 51,
            "help": {
                "Id": 24,
                "cypher": 1,
                "cathegory": null,
                "order": 3,
                "points": -60,
                "type": "A",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2025-05-24T10:53:27"
            }
        },
        {
            "id_team": 22,
            "help": {
                "Id": 29,
                "cypher": 3,
                "cathegory": null,
                "order": 2,
                "points": 30,
                "type": "I",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2025-05-24T11:09:07"
            }
        },
        {
            "id_team": 26,
            "help": {
                "Id": 9,
                "cypher": 3,
                "cathegory": null,
                "order": 3,
                "points": 30,
                "type": "A",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2025-05-24T11:23:12"
            }
        },
        {
            "id_team": 47,
            "help": {
                "Id": 31,
                "cypher": 4,
                "cathegory": null,
                "order": 1,
                "points": 30,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2025-05-24T11:29:37"
            }
        },
        {
            "id_team": 30,
            "help": {
                "Id": 13,
                "cypher": 5,
                "cathegory": null,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2025-05-24T11:33:14"
            }
        },
        {
            "id_team": 30,
            "help": {
                "Id": 14,
                "cypher": 5,
                "cathegory": null,
                "order": 2,
                "points": 15,
                "type": "I",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2025-05-24T11:33:28"
            }
        },
        {
            "id_team": 5,
            "help": {
                "Id": 16,
                "cypher": 6,
                "cathegory": null,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2025-05-24T11:35:48"
            }
        },
        {
            "id_team": 30,
            "help": {
                "Id": 15,
                "cypher": 5,
                "cathegory": null,
                "order": 3,
                "points": 30,
                "type": "A",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2025-05-24T11:37:02"
            }
        },
        {
            "id_team": 55,
            "help": {
                "Id": 34,
                "cypher": 5,
                "cathegory": null,
                "order": 1,
                "points": 30,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2025-05-24T11:42:44"
            }
        },
        {
            "id_team": 25,
            "help": {
                "Id": 16,
                "cypher": 6,
                "cathegory": null,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2025-05-24T11:47:44"
            }
        },
        {
            "id_team": 29,
            "help": {
                "Id": 16,
                "cypher": 6,
                "cathegory": null,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2025-05-24T11:57:18"
            }
        },
        {
            "id_team": 17,
            "help": {
                "Id": 11,
                "cypher": 4,
                "cathegory": null,
                "order": 2,
                "points": 15,
                "type": "I",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2025-05-24T12:15:54"
            }
        },
        {
            "id_team": 17,
            "help": {
                "Id": 12,
                "cypher": 4,
                "cathegory": null,
                "order": 3,
                "points": 30,
                "type": "A",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2025-05-24T12:15:59"
            }
        },
        {
            "id_team": 24,
            "help": {
                "Id": 28,
                "cypher": 3,
                "cathegory": null,
                "order": 1,
                "points": 30,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2025-05-24T12:24:12"
            }
        },
        {
            "id_team": 58,
            "help": {
                "Id": 31,
                "cypher": 4,
                "cathegory": null,
                "order": 1,
                "points": 30,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2025-05-24T12:28:10"
            }
        },
        {
            "id_team": 58,
            "help": {
                "Id": 32,
                "cypher": 4,
                "cathegory": null,
                "order": 2,
                "points": 30,
                "type": "I",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2025-05-24T12:30:13"
            }
        },
        {
            "id_team": 24,
            "help": {
                "Id": 30,
                "cypher": 3,
                "cathegory": null,
                "order": 3,
                "points": -60,
                "type": "A",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2025-05-24T12:31:56"
            }
        },
        {
            "id_team": 19,
            "help": {
                "Id": 16,
                "cypher": 6,
                "cathegory": null,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2025-05-24T12:32:21"
            }
        },
        {
            "id_team": 51,
            "help": {
                "Id": 28,
                "cypher": 3,
                "cathegory": null,
                "order": 1,
                "points": 30,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2025-05-24T12:32:47"
            }
        },
        {
            "id_team": 51,
            "help": {
                "Id": 29,
                "cypher": 3,
                "cathegory": null,
                "order": 2,
                "points": 30,
                "type": "I",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2025-05-24T12:32:52"
            }
        },
        {
            "id_team": 51,
            "help": {
                "Id": 30,
                "cypher": 3,
                "cathegory": null,
                "order": 3,
                "points": -60,
                "type": "A",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2025-05-24T12:33:03"
            }
        },
        {
            "id_team": 19,
            "help": {
                "Id": 17,
                "cypher": 6,
                "cathegory": null,
                "order": 2,
                "points": 15,
                "type": "I",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2025-05-24T12:33:19"
            }
        },
        {
            "id_team": 19,
            "help": {
                "Id": 18,
                "cypher": 6,
                "cathegory": null,
                "order": 3,
                "points": 30,
                "type": "A",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2025-05-24T12:34:56"
            }
        },
        {
            "id_team": 58,
            "help": {
                "Id": 33,
                "cypher": 4,
                "cathegory": null,
                "order": 3,
                "points": -60,
                "type": "A",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2025-05-24T12:35:01"
            }
        },
        {
            "id_team": 38,
            "help": {
                "Id": 31,
                "cypher": 4,
                "cathegory": null,
                "order": 1,
                "points": 30,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2025-05-24T12:38:54"
            }
        },
        {
            "id_team": 38,
            "help": {
                "Id": 32,
                "cypher": 4,
                "cathegory": null,
                "order": 2,
                "points": 30,
                "type": "I",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2025-05-24T12:38:57"
            }
        },
        {
            "id_team": 38,
            "help": {
                "Id": 33,
                "cypher": 4,
                "cathegory": null,
                "order": 3,
                "points": -60,
                "type": "A",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2025-05-24T12:39:08"
            }
        },
        {
            "id_team": 22,
            "help": {
                "Id": 31,
                "cypher": 4,
                "cathegory": null,
                "order": 1,
                "points": 30,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2025-05-24T12:48:40"
            }
        },
        {
            "id_team": 13,
            "help": {
                "Id": 33,
                "cypher": 4,
                "cathegory": null,
                "order": 3,
                "points": -60,
                "type": "A",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2025-05-24T12:49:52"
            }
        },
        {
            "id_team": 11,
            "help": {
                "Id": 37,
                "cypher": 6,
                "cathegory": null,
                "order": 1,
                "points": 30,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2025-05-24T12:51:28"
            }
        },
        {
            "id_team": 51,
            "help": {
                "Id": 31,
                "cypher": 4,
                "cathegory": null,
                "order": 1,
                "points": 30,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2025-05-24T12:57:14"
            }
        },
        {
            "id_team": 36,
            "help": {
                "Id": 37,
                "cypher": 6,
                "cathegory": null,
                "order": 1,
                "points": 30,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2025-05-24T12:58:12"
            }
        },
        {
            "id_team": 11,
            "help": {
                "Id": 38,
                "cypher": 6,
                "cathegory": null,
                "order": 2,
                "points": 30,
                "type": "I",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2025-05-24T12:59:50"
            }
        },
        {
            "id_team": 9,
            "help": {
                "Id": 37,
                "cypher": 6,
                "cathegory": null,
                "order": 1,
                "points": 30,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2025-05-24T13:02:29"
            }
        },
        {
            "id_team": 57,
            "help": {
                "Id": 43,
                "cypher": 8,
                "cathegory": null,
                "order": 1,
                "points": 30,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2025-05-24T13:02:45"
            }
        },
        {
            "id_team": 9,
            "help": {
                "Id": 38,
                "cypher": 6,
                "cathegory": null,
                "order": 2,
                "points": 30,
                "type": "I",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2025-05-24T13:05:29"
            }
        },
        {
            "id_team": 21,
            "help": {
                "Id": 37,
                "cypher": 6,
                "cathegory": null,
                "order": 1,
                "points": 30,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2025-05-24T13:12:00"
            }
        },
        {
            "id_team": 57,
            "help": {
                "Id": 44,
                "cypher": 8,
                "cathegory": null,
                "order": 2,
                "points": 30,
                "type": "I",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2025-05-24T13:14:02"
            }
        },
        {
            "id_team": 15,
            "help": {
                "Id": 38,
                "cypher": 6,
                "cathegory": null,
                "order": 2,
                "points": 30,
                "type": "I",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2025-05-24T13:21:01"
            }
        },
        {
            "id_team": 9,
            "help": {
                "Id": 39,
                "cypher": 6,
                "cathegory": null,
                "order": 3,
                "points": -60,
                "type": "A",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2025-05-24T13:22:26"
            }
        },
        {
            "id_team": 48,
            "help": {
                "Id": 37,
                "cypher": 6,
                "cathegory": null,
                "order": 1,
                "points": 30,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2025-05-24T13:24:34"
            }
        },
        {
            "id_team": 11,
            "help": {
                "Id": 40,
                "cypher": 7,
                "cathegory": null,
                "order": 1,
                "points": 30,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2025-05-24T13:34:55"
            }
        },
        {
            "id_team": 48,
            "help": {
                "Id": 38,
                "cypher": 6,
                "cathegory": null,
                "order": 2,
                "points": 30,
                "type": "I",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2025-05-24T13:39:38"
            }
        },
        {
            "id_team": 21,
            "help": {
                "Id": 40,
                "cypher": 7,
                "cathegory": null,
                "order": 1,
                "points": 30,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2025-05-24T13:54:16"
            }
        },
        {
            "id_team": 44,
            "help": {
                "Id": 23,
                "cypher": 1,
                "cathegory": null,
                "order": 2,
                "points": 30,
                "type": "I",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2025-05-24T09:46:09"
            }
        },
        {
            "id_team": 14,
            "help": {
                "Id": 1,
                "cypher": 1,
                "cathegory": null,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2025-05-24T09:48:38"
            }
        },
        {
            "id_team": 38,
            "help": {
                "Id": 22,
                "cypher": 1,
                "cathegory": null,
                "order": 1,
                "points": 30,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2025-05-24T09:55:59"
            }
        },
        {
            "id_team": 58,
            "help": {
                "Id": 22,
                "cypher": 1,
                "cathegory": null,
                "order": 1,
                "points": 30,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2025-05-24T10:00:33"
            }
        },
        {
            "id_team": 38,
            "help": {
                "Id": 24,
                "cypher": 1,
                "cathegory": null,
                "order": 3,
                "points": -60,
                "type": "A",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2025-05-24T10:05:19"
            }
        },
        {
            "id_team": 47,
            "help": {
                "Id": 23,
                "cypher": 1,
                "cathegory": null,
                "order": 2,
                "points": 30,
                "type": "I",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2025-05-24T10:07:07"
            }
        },
        {
            "id_team": 58,
            "help": {
                "Id": 23,
                "cypher": 1,
                "cathegory": null,
                "order": 2,
                "points": 30,
                "type": "I",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2025-05-24T10:10:17"
            }
        },
        {
            "id_team": 21,
            "help": {
                "Id": 22,
                "cypher": 1,
                "cathegory": null,
                "order": 1,
                "points": 30,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2025-05-24T10:10:21"
            }
        },
        {
            "id_team": 42,
            "help": {
                "Id": 1,
                "cypher": 1,
                "cathegory": null,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2025-05-24T10:12:22"
            }
        },
        {
            "id_team": 9,
            "help": {
                "Id": 23,
                "cypher": 1,
                "cathegory": null,
                "order": 2,
                "points": 30,
                "type": "I",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2025-05-24T10:13:51"
            }
        },
        {
            "id_team": 42,
            "help": {
                "Id": 2,
                "cypher": 1,
                "cathegory": null,
                "order": 2,
                "points": 15,
                "type": "I",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2025-05-24T10:20:56"
            }
        },
        {
            "id_team": 24,
            "help": {
                "Id": 23,
                "cypher": 1,
                "cathegory": null,
                "order": 2,
                "points": 30,
                "type": "I",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2025-05-24T10:21:09"
            }
        },
        {
            "id_team": 42,
            "help": {
                "Id": 3,
                "cypher": 1,
                "cathegory": null,
                "order": 3,
                "points": 30,
                "type": "A",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2025-05-24T10:26:31"
            }
        },
        {
            "id_team": 10,
            "help": {
                "Id": 2,
                "cypher": 1,
                "cathegory": null,
                "order": 2,
                "points": 15,
                "type": "I",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2025-05-24T10:27:16"
            }
        },
        {
            "id_team": 10,
            "help": {
                "Id": 3,
                "cypher": 1,
                "cathegory": null,
                "order": 3,
                "points": 30,
                "type": "A",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2025-05-24T10:27:27"
            }
        },
        {
            "id_team": 24,
            "help": {
                "Id": 29,
                "cypher": 3,
                "cathegory": null,
                "order": 2,
                "points": 30,
                "type": "I",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2025-05-24T12:24:20"
            }
        },
        {
            "id_team": 33,
            "help": {
                "Id": 37,
                "cypher": 6,
                "cathegory": null,
                "order": 1,
                "points": 30,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2025-05-24T12:53:21"
            }
        },
        {
            "id_team": 15,
            "help": {
                "Id": 37,
                "cypher": 6,
                "cathegory": null,
                "order": 1,
                "points": 30,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2025-05-24T13:01:11"
            }
        },
        {
            "id_team": 55,
            "help": {
                "Id": 43,
                "cypher": 8,
                "cathegory": null,
                "order": 1,
                "points": 30,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2025-05-24T13:06:14"
            }
        },
        {
            "id_team": 58,
            "help": {
                "Id": 37,
                "cypher": 6,
                "cathegory": null,
                "order": 1,
                "points": 30,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2025-05-24T13:33:32"
            }
        },
        {
            "id_team": 58,
            "help": {
                "Id": 38,
                "cypher": 6,
                "cathegory": null,
                "order": 2,
                "points": 30,
                "type": "I",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2025-05-24T13:34:10"
            }
        },
        {
            "id_team": 24,
            "help": {
                "Id": 22,
                "cypher": 1,
                "cathegory": null,
                "order": 1,
                "points": 30,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2025-05-24T09:51:39"
            }
        },
        {
            "id_team": 17,
            "help": {
                "Id": 1,
                "cypher": 1,
                "cathegory": null,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2025-05-24T09:54:17"
            }
        },
        {
            "id_team": 26,
            "help": {
                "Id": 1,
                "cypher": 1,
                "cathegory": null,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2025-05-24T10:01:41"
            }
        },
        {
            "id_team": 41,
            "help": {
                "Id": 1,
                "cypher": 1,
                "cathegory": null,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2025-05-24T09:54:26"
            }
        },
        {
            "id_team": 22,
            "help": {
                "Id": 24,
                "cypher": 1,
                "cathegory": null,
                "order": 3,
                "points": -60,
                "type": "A",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2025-05-24T09:55:05"
            }
        },
        {
            "id_team": 57,
            "help": {
                "Id": 22,
                "cypher": 1,
                "cathegory": null,
                "order": 1,
                "points": 30,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2025-05-24T09:55:45"
            }
        },
        {
            "id_team": 17,
            "help": {
                "Id": 2,
                "cypher": 1,
                "cathegory": null,
                "order": 2,
                "points": 15,
                "type": "I",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2025-05-24T09:55:55"
            }
        },
        {
            "id_team": 52,
            "help": {
                "Id": 1,
                "cypher": 1,
                "cathegory": null,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2025-05-24T09:56:29"
            }
        },
        {
            "id_team": 38,
            "help": {
                "Id": 23,
                "cypher": 1,
                "cathegory": null,
                "order": 2,
                "points": 30,
                "type": "I",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2025-05-24T09:56:31"
            }
        },
        {
            "id_team": 48,
            "help": {
                "Id": 22,
                "cypher": 1,
                "cathegory": null,
                "order": 1,
                "points": 30,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2025-05-24T10:03:09"
            }
        },
        {
            "id_team": 33,
            "help": {
                "Id": 23,
                "cypher": 1,
                "cathegory": null,
                "order": 2,
                "points": 30,
                "type": "I",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2025-05-24T10:03:32"
            }
        },
        {
            "id_team": 47,
            "help": {
                "Id": 22,
                "cypher": 1,
                "cathegory": null,
                "order": 1,
                "points": 30,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2025-05-24T10:05:30"
            }
        },
        {
            "id_team": 17,
            "help": {
                "Id": 3,
                "cypher": 1,
                "cathegory": null,
                "order": 3,
                "points": 30,
                "type": "A",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2025-05-24T10:10:16"
            }
        },
        {
            "id_team": 51,
            "help": {
                "Id": 22,
                "cypher": 1,
                "cathegory": null,
                "order": 1,
                "points": 30,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2025-05-24T10:10:53"
            }
        },
        {
            "id_team": 47,
            "help": {
                "Id": 24,
                "cypher": 1,
                "cathegory": null,
                "order": 3,
                "points": -60,
                "type": "A",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2025-05-24T10:13:59"
            }
        },
        {
            "id_team": 19,
            "help": {
                "Id": 1,
                "cypher": 1,
                "cathegory": null,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2025-05-24T10:18:15"
            }
        },
        {
            "id_team": 19,
            "help": {
                "Id": 2,
                "cypher": 1,
                "cathegory": null,
                "order": 2,
                "points": 15,
                "type": "I",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2025-05-24T10:18:34"
            }
        },
        {
            "id_team": 19,
            "help": {
                "Id": 3,
                "cypher": 1,
                "cathegory": null,
                "order": 3,
                "points": 30,
                "type": "A",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2025-05-24T10:19:01"
            }
        },
        {
            "id_team": 21,
            "help": {
                "Id": 23,
                "cypher": 1,
                "cathegory": null,
                "order": 2,
                "points": 30,
                "type": "I",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2025-05-24T10:20:36"
            }
        },
        {
            "id_team": 10,
            "help": {
                "Id": 1,
                "cypher": 1,
                "cathegory": null,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2025-05-24T10:23:57"
            }
        },
        {
            "id_team": 21,
            "help": {
                "Id": 24,
                "cypher": 1,
                "cathegory": null,
                "order": 3,
                "points": -60,
                "type": "A",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2025-05-24T10:26:56"
            }
        },
        {
            "id_team": 56,
            "help": {
                "Id": 1,
                "cypher": 1,
                "cathegory": null,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2025-05-24T10:29:44"
            }
        },
        {
            "id_team": 13,
            "help": {
                "Id": 22,
                "cypher": 1,
                "cathegory": null,
                "order": 1,
                "points": 30,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2025-05-24T10:30:40"
            }
        },
        {
            "id_team": 38,
            "help": {
                "Id": 25,
                "cypher": 2,
                "cathegory": null,
                "order": 1,
                "points": 30,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2025-05-24T10:32:59"
            }
        },
        {
            "id_team": 13,
            "help": {
                "Id": 23,
                "cypher": 1,
                "cathegory": null,
                "order": 2,
                "points": 30,
                "type": "I",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2025-05-24T10:38:53"
            }
        },
        {
            "id_team": 17,
            "help": {
                "Id": 4,
                "cypher": 2,
                "cathegory": null,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2025-05-24T10:41:30"
            }
        },
        {
            "id_team": 13,
            "help": {
                "Id": 24,
                "cypher": 1,
                "cathegory": null,
                "order": 3,
                "points": -60,
                "type": "A",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2025-05-24T10:49:40"
            }
        },
        {
            "id_team": 58,
            "help": {
                "Id": 25,
                "cypher": 2,
                "cathegory": null,
                "order": 1,
                "points": 30,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2025-05-24T10:50:40"
            }
        },
        {
            "id_team": 22,
            "help": {
                "Id": 28,
                "cypher": 3,
                "cathegory": null,
                "order": 1,
                "points": 30,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2025-05-24T11:00:26"
            }
        },
        {
            "id_team": 49,
            "help": {
                "Id": 13,
                "cypher": 5,
                "cathegory": null,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2025-05-24T11:07:37"
            }
        },
        {
            "id_team": 44,
            "help": {
                "Id": 28,
                "cypher": 3,
                "cathegory": null,
                "order": 1,
                "points": 30,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2025-05-24T11:08:18"
            }
        },
        {
            "id_team": 44,
            "help": {
                "Id": 29,
                "cypher": 3,
                "cathegory": null,
                "order": 2,
                "points": 30,
                "type": "I",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2025-05-24T11:09:00"
            }
        },
        {
            "id_team": 17,
            "help": {
                "Id": 7,
                "cypher": 3,
                "cathegory": null,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2025-05-24T11:09:45"
            }
        },
        {
            "id_team": 26,
            "help": {
                "Id": 7,
                "cypher": 3,
                "cathegory": null,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2025-05-24T11:23:04"
            }
        },
        {
            "id_team": 26,
            "help": {
                "Id": 8,
                "cypher": 3,
                "cathegory": null,
                "order": 2,
                "points": 15,
                "type": "I",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2025-05-24T11:23:08"
            }
        },
        {
            "id_team": 12,
            "help": {
                "Id": 16,
                "cypher": 6,
                "cathegory": null,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2025-05-24T11:26:10"
            }
        },
        {
            "id_team": 38,
            "help": {
                "Id": 28,
                "cypher": 3,
                "cathegory": null,
                "order": 1,
                "points": 30,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2025-05-24T11:26:22"
            }
        },
        {
            "id_team": 12,
            "help": {
                "Id": 17,
                "cypher": 6,
                "cathegory": null,
                "order": 2,
                "points": 15,
                "type": "I",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2025-05-24T11:26:32"
            }
        },
        {
            "id_team": 38,
            "help": {
                "Id": 29,
                "cypher": 3,
                "cathegory": null,
                "order": 2,
                "points": 30,
                "type": "I",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2025-05-24T11:31:20"
            }
        },
        {
            "id_team": 47,
            "help": {
                "Id": 32,
                "cypher": 4,
                "cathegory": null,
                "order": 2,
                "points": 30,
                "type": "I",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2025-05-24T11:32:05"
            }
        },
        {
            "id_team": 38,
            "help": {
                "Id": 30,
                "cypher": 3,
                "cathegory": null,
                "order": 3,
                "points": -60,
                "type": "A",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2025-05-24T11:39:44"
            }
        },
        {
            "id_team": 25,
            "help": {
                "Id": 17,
                "cypher": 6,
                "cathegory": null,
                "order": 2,
                "points": 15,
                "type": "I",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2025-05-24T11:49:04"
            }
        },
        {
            "id_team": 48,
            "help": {
                "Id": 31,
                "cypher": 4,
                "cathegory": null,
                "order": 1,
                "points": 30,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2025-05-24T11:58:25"
            }
        },
        {
            "id_team": 17,
            "help": {
                "Id": 10,
                "cypher": 4,
                "cathegory": null,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2025-05-24T12:15:43"
            }
        },
        {
            "id_team": 57,
            "help": {
                "Id": 37,
                "cypher": 6,
                "cathegory": null,
                "order": 1,
                "points": 30,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2025-05-24T12:22:38"
            }
        },
        {
            "id_team": 13,
            "help": {
                "Id": 31,
                "cypher": 4,
                "cathegory": null,
                "order": 1,
                "points": 30,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2025-05-24T12:45:49"
            }
        },
        {
            "id_team": 13,
            "help": {
                "Id": 32,
                "cypher": 4,
                "cathegory": null,
                "order": 2,
                "points": 30,
                "type": "I",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2025-05-24T12:45:56"
            }
        }
    ]
} as TStats
